import { Location } from 'history'
import { ReactElement, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router'
import { Outlet } from 'react-router-dom'
import { ROUTES } from 'src/routing/routes'
import { NestedRoute, Route, SecondLevelRoute } from 'src/routing/routing'
import { SecondLevelNavigation, SecondLevelNavigationContainer } from 'src/routing/SecondLevelNavigation'
import { usePermissionsForKapProgram } from 'src/service/security/PermissionHook'
import { PageLayout } from 'src/shared/layout/PageLayout'
import { NotAuthorized } from 'src/shared/not-authorized/NotAuthorized'

const resolveActiveRoute = (location: Location, programId: string): SecondLevelRoute => {
  const nested = ROUTES.KapDetailsRoot!.nested! as unknown as NestedRoute
  const activeRoute = Object.keys(nested).find(
    (key) =>
      location.pathname.endsWith(nested[key].path) ||
      (ROUTES.KapDetailsRoot.params({ programId }) === location.pathname && nested[key].primary),
  ) as string
  return nested[activeRoute] as SecondLevelRoute
}

export const KapProgramDetailsIndexPage = (): ReactElement => {
  const { programId } = useParams()
  const location = useLocation()

  const { loading, canView, canViewCantonRestricted } = usePermissionsForKapProgram(parseInt(programId as string))

  const [activeRoute, setActiveRoute] = useState<SecondLevelRoute>(() => {
    return resolveActiveRoute(location, programId as string)
  })

  useEffect(() => {
    const activeRoute = resolveActiveRoute(location, programId as string)
    setActiveRoute(activeRoute)
  }, [location, programId])

  const showNavigation = activeRoute && !activeRoute.hideNavigation

  const isNestedRouteAllowedAdditionalValidation = (nestedRoute: SecondLevelRoute): boolean => {
    switch (nestedRoute) {
      case ROUTES.KapDetailsRoot.nested.Financials: {
        return canViewCantonRestricted
      }

      default:
        return true
    }
  }

  if (!loading && !canView) {
    return <NotAuthorized />
  }

  return (
    <>
      {!loading && (
        <SecondLevelNavigationContainer $showNavigation={showNavigation}>
          {showNavigation && (
            <PageLayout>
              <SecondLevelNavigation
                activeRoute={activeRoute}
                route={ROUTES.KapDetailsRoot as unknown as Route}
                baseUrl={ROUTES.KapDetailsRoot.params({ programId })}
                isNestedRouteAllowed={isNestedRouteAllowedAdditionalValidation}
              />
            </PageLayout>
          )}
          <Outlet />
        </SecondLevelNavigationContainer>
      )}
    </>
  )
}
